import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/auth.model';

/**
 * Usage in route definition:
 *   canActivate: [roleGuard],
 *   data: { roles: ['admin'] }
 */
export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const allowedRoles = (route.data['roles'] as UserRole[] | undefined) ?? [];

  if (allowedRoles.length === 0) {
    return true;
  }

  const user = auth.currentUser();
  if (!user) {
    return router.createUrlTree(['/auth/login']);
  }

  if (allowedRoles.includes(user.role)) {
    return true;
  }

  return router.createUrlTree(['/acesso-negado']);
};
